export const CUSTOMER_TYPES = ['Bireysel', 'Kurumsal'];

export const LICENSE_PLATE_STATUSES = [
    'Mevcut Plaka',
    'Eskiden İşlem Görmüş Plaka',
    'Eski Plaka',
];

export const DOCUMENT_REQUEST_STATUSES = [
    'Evraklar Geldi',
    'Resim Eksik',
    'KM Eksik',
    'Ruhsat Eksik',
    'KTT Eksik',
    'Poliçe Eksik',
    'Fatura Eksik',
    'Eksper Raporu Eksik',
    'Kusur Durumu Belgesi Eksik',
];

export const WHOSE_INSURANCE_VALUES = [
    'MÜVEKKİL TRAFİK SİGORTA',
    'MÜVEKKİL KASKO',
    'KARŞI TARAF TRAFİK SİGORTA',
    'KARŞI TARAF KASKO',
];

export const INSURANCE_APPLICATION_TYPES = ['Kep', 'Mail', 'Elden'];

export const PAYMENT_METHODS = ['NAKİT', 'KREDİ KARTI', 'HAVALE', 'PTT'];

export const EXPERT_REPORT_TYPES = [
    'Değer Kaybı',
    'Hasar Bedeli',
    'Hasar Farkı',
    'Değer Kaybı Kusur',
    'Hasar Bedeli Kusur',
    'Hasar Farkı Kusur',
    'Ek Rapor',
];

export const ACTIONS_FOR_REPORT = ['Beyan', 'Islah', 'İtiraz'];

export const APPRAISAL_FEE_STATUSES = ['Kabul', 'Ret', 'Kısmi Kabul'];

export const RULING_RESULTS = ['Kabul', 'Kısmi Kabul', 'KVYO', 'Ret'];

export const RULING_TYPES = ['Normal', 'Tavzih', 'Tashih', 'İtiraz'];

export const ACTIONS_FOR_RULING = ['Uygun', 'İtiraz', 'Tavzih', 'Tashih', 'Temyiz'];

export const ENFORCEMENT_TYPES = ['İlamlı', 'İlamsız', 'İdari'];

export const TRACKING_DETAIL_TYPES = ['HM', 'DK', 'LİMİT', 'ST', 'AHD', 'HSR', 'HF'];

export const ENFORCEMENT_STATUSES = ['Açık', 'Kapalı', 'Vazgeçme', 'Beklemede'];

export const FILE_CLOSE_DESCRIPTIONS = [
    'Sulh Anlaşması Nedeniyle',
    'Eksper İncelemesi Sonucu Aracın Hasar Tutarının Eksik Olduğu Kanaatine Varıldığı',
    'Sigortalı/Zarar Gören Tarafından İstenmediği',
    'Sigortalının/Zarar Görenin Ulaşılamaması',
    'Eksper Raporu Alınıp İnceleme Yapıldıktan Sonra Dosyanın Gereksiz Olduğu Tespit Edildiği',
    'Başvurunun Yasal Süresi Geçtiği',
    'Maddi Hasarı Bulunmadığı',
    'Yaralanma Söz Konusu Olmadığı',
    'Dosyada Hukuki Problem Olduğu',
    'Evrakların Eksik/Hatalı Olduğu',
    'Sigortalı Aleyhine Haksızlık Olmadığı',
    'Objektif Kusur Değerlendirmesi',
    'Başka Şirkete Dosya Açıldığı',
    'Mükerrer/Devam Dosyası Olduğu',
    'Ticari Araç Başvurusu Olduğu',
    'Basit Onarım İşi Olduğu',
    'Başvurudan Vazgeçildiği',
    'MEAEM Görevi Dışı Olduğu',
    'Bilgi Edinme Başvurusu Olduğu',
    'Ceza Avukatı Tutulduğu İçin Takip Edilmeyeceği',
    'İcra Takibinin Başlatıldığı',
    'Dava Açıldığı',
    'Şikayetin Geri Çekildiği',
    'Diğer',
];
